// extracted by mini-css-extract-plugin
export default {"container":"t9-z","creativeContainer":"u9-z","copy":"v9-z","cta":"w9-z","disabled":"x9-z","flipped":"y9-z","productCard":"z9-z"};